import React from "react";
import SettingsPage from "../../../components/List/SettingsList";
import { useTranslation } from "react-i18next";

const GenderSettingsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <SettingsPage
            title={t("common.gender")}
            fetchUrl="/itemApi/GetGenderList"
            createOrUpdateUrl="itemApi/CreateOrUpdateGender"
            deleteUrl="itemApi/DeleteGender"
            codeGenerationDisabled={ true}
        />
    );
};

export default GenderSettingsPage;
